<template>
  <div
    class="row match-height"
    v-bind:class="{ fullscreen_expand: isFullscreen }"
  >
    <div class="col-xl-12 col-lg-12">
      <div class="card">
        <div class="loadingDataPosition">
          <div class="card-header">
            <h4 class="card-title">CTE</h4>
            <a class="heading-elements-toggle"
              ><i
                class="fa fa-ellipsis-v font-medium-3"
                @click="setSubMenuShowHideFw(getSubMenuShowHideFw())"
              ></i
            ></a>
            <div
              class="heading-elements"
              v-bind:class="{
                visible: getSubMenuShowHideFw(),
                '': !getSubMenuShowHideFw(),
              }"
            >
              <ul class="list-inline mb-0">
                <li>
                  <a @click="onFilterReset()" v-b-tooltip title="Atualizar"
                    ><i class="ft-rotate-cw"></i
                  ></a>
                </li>
                <li>
                  <a
                    @click="expandFullscreen()"
                    v-b-tooltip
                    title="Expande a tela"
                    v-if="!isFullscreen"
                    ><i class="ft-maximize"></i
                  ></a>
                </li>
                <li>
                  <a
                    @click="expandFullscreen()"
                    v-b-tooltip
                    title="Minimiza a tela"
                    v-if="isFullscreen"
                    ><i class="ft-minimize"></i
                  ></a>
                </li>
              </ul>
            </div>
          </div>
          <div class="card-content">
            <div class="table-responsive col-md-12">
              <b-row class="mb-1">
                <b-col>
                  <label class="form-label"
                    >Quantidade de horas para cancelamento</label
                  >
                  <b-form-input
                    type="text"
                    placeholder="Horas"
                    v-model="form.qtde_horas_cancelamento"
                  >
                  </b-form-input>
                  <b-form-feedback
                    class="text-danger"
                    v-text="form.errors.get('qtde_horas_cancelamento')"
                    v-if="form.errors.has('qtde_horas_cancelamento')"
                  ></b-form-feedback>
                </b-col>

                <b-col>
                  <label class="form-label">COTM</label>
                  <b-form-input
                    type="text"
                    placeholder="COTM"
                    v-model="form.cotm"
                  >
                  </b-form-input>
                  <b-form-feedback
                    class="text-danger"
                    v-text="form.errors.get('cotm')"
                    v-if="form.errors.has('cotm')"
                  ></b-form-feedback>
                </b-col>
                <b-col>
                  <label class="form-label">RNTRC</label>
                  <b-form-input
                    type="text"
                    placeholder="RNTRC"
                    v-model="form.rntrc"
                  >
                  </b-form-input>
                  <b-form-feedback
                    class="text-danger"
                    v-text="form.errors.get('rntrc')"
                    v-if="form.errors.has('rntrc')"
                  ></b-form-feedback>
                </b-col>
                <b-col>
                  <label class="form-label">Numeração de cliente</label>
                  <b-form-input
                    type="text"
                    placeholder="Número Cliente"
                    v-model="form.num_cliente"
                  >
                  </b-form-input>
                  <b-form-feedback
                    class="text-danger"
                    v-text="form.errors.get('num_cliente')"
                    v-if="form.errors.has('num_cliente')"
                  ></b-form-feedback>
                </b-col>
                <b-col>
                  <label class="form-label">Cor do sistema</label>
                  <multiselect
                    v-model="corDoSistemaSelected"
                    :options="this.$parent.optionsCorSistema"
                    track-by="value"
                    label="label"
                    :hide-selected="true"
                    placeholder="Selecione"
                    tag-placeholder="Selecionar"
                    select-label="Selecionar"
                    selected-label="Selecionado"
                    deselect-label="Remover"
                  ></multiselect>
                  <b-form-feedback
                    class="text-danger"
                    v-text="form.errors.get('cor_sistema')"
                    v-if="form.errors.has('cor_sistema')"
                  ></b-form-feedback>
                </b-col>
              </b-row>
              <b-row class="mb-1">
                <b-col>
                  <label class="form-label">Custo para Advalorem</label>
                  <multiselect
                    v-model="custoAdvaloremSelected"
                    :options="this.$parent.optionsCustos"
                    track-by="value"
                    label="label"
                    :hide-selected="true"
                    placeholder="Selecione"
                    tag-placeholder="Selecionar"
                    select-label="Selecionar"
                    selected-label="Selecionado"
                    deselect-label="Remover"
                  ></multiselect>
                  <b-form-feedback
                    class="text-danger"
                    v-text="form.errors.get('custo_advalorem.value')"
                    v-if="form.errors.has('custo_advalorem.value')"
                  ></b-form-feedback>
                </b-col>
                <b-col>
                  <label class="form-label">PRM Geral Retira</label>
                  <b-form-group>
                    <b-form-radio-group
                      v-model="form.prm_geral_retira"
                      :options="this.$parent.optionsPrmGeralRetira"
                      name="prm_geral_retira"
                      plain
                    ></b-form-radio-group>
                  </b-form-group>
                  <b-form-feedback
                    class="text-danger"
                    v-text="form.errors.get('prm_geral_retira.value')"
                    v-if="form.errors.has('prm_geral_retira.value')"
                  ></b-form-feedback>
                </b-col>
                <b-col>
                  <label class="form-label">Transferencia Interna</label>
                  <b-form-group>
                    <b-form-radio-group
                      v-model="form.transferencia_interna"
                      :options="this.$parent.optionsTransferenciaInterna"
                      name="transferencia_interna"
                      plain
                    ></b-form-radio-group>
                  </b-form-group>
                  <b-form-feedback
                    class="text-danger"
                    v-text="form.errors.get('transferencia_interna.value')"
                    v-if="form.errors.has('transferencia_interna.value')"
                  ></b-form-feedback>
                </b-col>
                <b-col>
                  <label class="form-label"
                    >Mostra link de suporte no menu</label
                  >
                  <b-form-group>
                    <b-form-radio-group
                      v-model="form.link_suporte"
                      :options="this.$parent.optionsLinkSuporte"
                      name="link_suporte"
                      plain
                    ></b-form-radio-group>
                  </b-form-group>
                  <b-form-feedback
                    class="text-danger"
                    v-text="form.errors.get('link_suporte')"
                    v-if="form.errors.has('link_suporte')"
                  ></b-form-feedback>
                </b-col>
                <b-col>
                  <label class="form-label"
                    >Gera código automático para tomador</label
                  >
                  <b-form-group>
                    <b-form-radio-group
                      v-model="form.gera_num_cliente"
                      :options="this.$parent.optionsGeraNumCliente"
                      name="gera_num_cliente"
                      plain
                    ></b-form-radio-group>
                  </b-form-group>
                  <b-form-feedback
                    class="text-danger"
                    v-text="form.errors.get('gera_num_cliente.value')"
                    v-if="form.errors.has('gera_num_cliente.value')"
                  ></b-form-feedback>
                </b-col>
                <b-col>
                  <label class="form-label">Encerra Mdfe automático</label>
                  <b-form-group>
                    <b-form-radio-group
                      v-model="form.encerra_mdfe_automatico"
                      :options="this.$parent.optionsEncerraMdfeAutomatico"
                      name="encerra_mdfe_automatico"
                      plain
                    ></b-form-radio-group>
                  </b-form-group>
                  <b-form-feedback
                    class="text-danger"
                    v-text="form.errors.get('encerra_mdfe_automatico.value')"
                    v-if="form.errors.has('encerra_mdfe_automatico.value')"
                  ></b-form-feedback>
                </b-col>
                <b-col>
                  <label class="form-label"
                    >Encerrar automatico valor do cte menor</label
                  >
                  <b-form-group>
                    <b-form-radio-group
                      v-model="form.encerra_automatico_vlr_cte_menor"
                      :options="
                        this.$parent.optionsEncerraAutomaticoVlrCteMenor
                      "
                      name="encerra_automatico_vlr_cte_menor"
                      plain
                    ></b-form-radio-group>
                  </b-form-group>
                  <b-form-feedback
                    class="text-danger"
                    v-text="
                      form.errors.get('encerra_automatico_vlr_cte_menor.value')
                    "
                    v-if="
                      form.errors.has('encerra_automatico_vlr_cte_menor.value')
                    "
                  ></b-form-feedback>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="2">
                  <label class="form-label">Vlr Despacho</label>
                  <b-form-group>
                    <b-form-radio-group
                      v-model="form.tp_vlr_despacho"
                      :options="this.$parent.optionsTpVlrDespacho"
                      name="tp_vlr_despacho"
                      plain
                    ></b-form-radio-group>
                  </b-form-group>
                  <b-form-feedback
                    class="text-danger"
                    v-text="form.errors.get('tp_vlr_despacho.value')"
                    v-if="form.errors.has('tp_vlr_despacho.value')"
                  ></b-form-feedback>
                </b-col>
                <b-col sm="2">
                  <label class="form-label">Valida regra adiantamento</label>
                  <b-form-group>
                    <b-form-radio-group
                      v-model="form.valida_regra_adiantamento"
                      :options="this.$parent.optionsValidaRegraAdiantamento"
                      name="valida_regra_adiantamento"
                      plain
                    ></b-form-radio-group>
                  </b-form-group>
                  <b-form-feedback
                    class="text-danger"
                    v-text="form.errors.get('encerra_mdfe_automatico.value')"
                    v-if="form.errors.has('encerra_mdfe_automatico.value')"
                  ></b-form-feedback>
                </b-col>
                <b-col sm="2">
                  <label class="form-label">CTe Transferência - Cálculo individual NF</label>
                  <b-form-group>
                    <b-form-radio-group
                        v-model="form.doc_transf_calc_indiv"
                        :options="this.$parent.optionsValidaTransfCalcIndiv"
                        name="doc_transf_calc_indiv"
                        plain
                    ></b-form-radio-group>
                  </b-form-group>
                  <b-form-feedback
                      class="text-danger"
                      v-text="form.errors.get('doc_transf_calc_indiv.value')"
                      v-if="form.errors.has('doc_transf_calc_indiv.value')"
                  ></b-form-feedback>
                </b-col>
                <b-col md="2" class="mb-1">
                  <label class="form-label"
                    >Valor de tolerância para adiantamento(%)</label
                  >
                  <currency-input
                    class="form-control"
                    v-model="form.vlr_tolerancia_adiantamento"
                    placeholder=""
                    :auto-decimal-mode="true"
                    :locale="getCurrency.locale"
                    style="text-align: right"
                    :currency="{ prefix: '% ' }"
                    :distraction-free="getCurrency"
                  />
                  <b-form-feedback
                    class="text-danger"
                    v-text="form.errors.get('vlr_tolerancia_spot')"
                    v-if="form.errors.has('vlr_tolerancia_spot')"
                  ></b-form-feedback>
                </b-col>
              </b-row>
              <b-row class="mb-1"> </b-row>
              <b-row>
                <b-col>
                  <label class="form-label"
                    >Tipo do email para envio de XML e DACTE (Vinculado ao
                    tomador)</label
                  >
                  <multiselect
                    v-model="partpemaCteSelected"
                    :options="this.$parent.optionsParamTpEmailCte"
                    track-by="value"
                    label="label"
                    :hide-selected="true"
                    placeholder="Selecione"
                    tag-placeholder="Selecionar"
                    select-label="Selecionar"
                    selected-label="Selecionado"
                    deselect-label="Remover"
                  ></multiselect>
                  <b-form-feedback
                    class="text-danger"
                    v-text="form.errors.get('partpema_cte.value')"
                    v-if="form.errors.has('partpema_cte.value')"
                  ></b-form-feedback>
                </b-col>
                <b-col>
                  <label class="form-label"
                    >Tipo do email para averbação (Vinculado aos fornecedores
                    para envio do XML para emissão do MDFE do fornecedor)</label
                  >
                  <multiselect
                    v-model="partpemaSelected"
                    :options="this.$parent.optionsParamTpEmail"
                    track-by="value"
                    label="label"
                    :hide-selected="true"
                    placeholder="Selecione"
                    tag-placeholder="Selecionar"
                    select-label="Selecionar"
                    selected-label="Selecionado"
                    deselect-label="Remover"
                  ></multiselect>
                  <b-form-feedback
                    class="text-danger"
                    v-text="form.errors.get('partpema.value')"
                    v-if="form.errors.has('partpema.value')"
                  ></b-form-feedback>
                </b-col>

                <b-col>
                  <label class="form-label"
                    >Status Cancelamento (Permite Cancelar CTE sem ele estar com
                    Status Exportado ERP)</label
                  ><br />
                  <toggle-button
                    @change="onChangeStatusCancelamento"
                    v-model="form.status_canc_exp_erp"
                    :value="this.form.status_canc_exp_erp"
                    :sync="true"
                    :width="100"
                    :height="28"
                    :labels="{ checked: 'Ativado', unchecked: 'Inativado' }"
                  />
                </b-col>

                <b-col>
                  <label class="form-label"
                    >Status Cancelamento Fatura (Permite Cancelar Fatura sem o
                    CTE estar cancelado)</label
                  ><br />
                  <toggle-button
                    @change="onChangeStatusCancelamentoFatura"
                    v-model="form.status_canc_cte_com_fatura"
                    :value="this.form.status_canc_cte_com_fatura"
                    :sync="true"
                    :width="100"
                    :height="28"
                    :labels="{ checked: 'Ativado', unchecked: 'Inativado' }"
                  />
                </b-col>
              </b-row>
              <b-row class="mt-2">
                <b-col md="1" class="mb-1">
                  <label class="form-label">Quantidade de horas de corte</label>
                  <b-form-input
                    type="text"
                    placeholder="Horas"
                    v-model="form.qtde_horas_corte"
                  >
                  </b-form-input>
                  <b-form-feedback
                    class="text-danger"
                    v-text="form.errors.get('qtde_horas_corte')"
                    v-if="form.errors.has('qtde_horas_corte')"
                  ></b-form-feedback>
                </b-col>
                <b-col md="1" class="mb-1">
                  <label class="form-label"
                    >Qtde.dias para carga Expedida</label
                  >
                  <b-form-input
                    type="text"
                    placeholder="Qtde. Dias"
                    v-model="form.qtde_dias_carga_expedida"
                  >
                  </b-form-input>
                  <b-form-feedback
                    class="text-danger"
                    v-text="form.errors.get('qtde_dias_carga_expedida')"
                    v-if="form.errors.has('qtde_dias_carga_expedida')"
                  ></b-form-feedback>
                </b-col>
                <b-col md="2" class="mb-1">
                  <label class="form-label"
                    >Qtde.dias para Expiração Gerenciamento de risco</label
                  >
                  <b-form-input
                    type="text"
                    placeholder="Qtde. Dias"
                    v-model="form.qtde_dias_expiracao_gr"
                  >
                  </b-form-input>
                  <b-form-feedback
                    class="text-danger"
                    v-text="form.errors.get('qtde_dias_expiracao_gr')"
                    v-if="form.errors.has('qtde_dias_expiracao_gr')"
                  ></b-form-feedback>
                </b-col>

                <b-col>
                  <label class="form-label"
                    >Controle Bloqueio de Ocorrências</label
                  ><br />
                  <toggle-button
                    @change="onChangeStatusBloqueioOcorrencia"
                    v-model="form.bloqueio_ocorrencia"
                    :value="this.form.bloqueio_ocorrencia"
                    :sync="true"
                    :width="100"
                    :height="28"
                    :labels="{ checked: 'Ativado', unchecked: 'Inativado' }"
                  />
                </b-col>
                <b-col md="2" class="mb-1">
                  <label class="form-label">Valor Tolerância Fatura</label>
                  <currency-input
                    class="form-control"
                    v-model="form.vlr_tolerancia_fatura"
                    placeholder=""
                    :auto-decimal-mode="true"
                    :locale="getCurrency.locale"
                    style="text-align: right"
                    :currency="{ prefix: 'R$ ' }"
                    :distraction-free="getCurrency"
                  />
                  <b-form-feedback
                    class="text-danger"
                    v-text="form.errors.get('vlr_tolerancia_fatura')"
                    v-if="form.errors.has('vlr_tolerancia_fatura')"
                  ></b-form-feedback>
                </b-col>
                <b-col md="2" class="mb-1">
                  <label class="form-label"
                    >Valor de tolerância para aprovação automática com tabela de
                    frete</label
                  >
                  <currency-input
                    class="form-control"
                    v-model="form.vlr_tolerancia_tabela_frete"
                    placeholder=""
                    :auto-decimal-mode="true"
                    :locale="getCurrency.locale"
                    style="text-align: right"
                    :currency="{ prefix: 'R$ ' }"
                    :distraction-free="getCurrency"
                  />
                  <b-form-feedback
                    class="text-danger"
                    v-text="form.errors.get('vlr_tolerancia_tabela_frete')"
                    v-if="form.errors.has('vlr_tolerancia_tabela_frete')"
                  ></b-form-feedback>
                </b-col>
                <b-col md="2" class="mb-1">
                  <label class="form-label"
                    >Valor de tolerância para aprovação automática - SPOT</label
                  >
                  <currency-input
                    class="form-control"
                    v-model="form.vlr_tolerancia_spot"
                    placeholder=""
                    :auto-decimal-mode="true"
                    :locale="getCurrency.locale"
                    style="text-align: right"
                    :currency="{ prefix: 'R$ ' }"
                    :distraction-free="getCurrency"
                  />
                  <b-form-feedback
                    class="text-danger"
                    v-text="form.errors.get('vlr_tolerancia_spot')"
                    v-if="form.errors.has('vlr_tolerancia_spot')"
                  ></b-form-feedback>
                </b-col>
              </b-row>
              <div class="row">
                <div class="col-md-12">
                  <div
                    class="float-right"
                    v-if="getPermission('conta.update.cte')"
                  >
                    <b-btn
                      @click="onUpdateCte()"
                      variant="secondary"
                      style="margin-top: 8px"
                      :disabled="isDisabled"
                    >
                      Salvar mudanças
                    </b-btn>
                  </div>
                </div>

                <div class="col-md-12 pt-1">
                  <h4 class="card-title">Certificado</h4>
                  <form enctype="multipart/form-data">
                    <b-row>
                      <b-col>
                        <span v-if="form_certificado.certificado_nome">
                          Certificado instalado:
                          <strong>{{
                            form_certificado.certificado_nome
                          }}</strong>
                        </span>
                        <label>Selecione ou arreste o arquivo </label>
                        <b-form-file
                          accept=".pfx"
                          v-model="form_certificado_file.file"
                          :state="Boolean(form_certificado_file.file)"
                          placeholder="Selecione ou arraste o arquivo aqui"
                          drop-placeholder="Solte aqui"
                        ></b-form-file>
                      </b-col>
                      <b-col>
                        <label class="form-label"
                          >Senha Certificado * Senha ocultada pro questões que
                          segurança</label
                        >
                        <b-form-input
                          type="password"
                          placeholder="Senha"
                          v-model="
                            form_certificado_file.password_certificado_a1
                          "
                        >
                        </b-form-input>
                        <b-form-feedback
                          class="text-danger"
                          v-text="
                            form_certificado_file.errors.get(
                              'password_certificado_a1'
                            )
                          "
                          v-if="
                            form_certificado_file.errors.has(
                              'password_certificado_a1'
                            )
                          "
                        ></b-form-feedback>
                      </b-col>
                      <b-col class="mb-1">
                        <label class="form-label"
                          >Data de Expiração
                          <span
                            v-b-tooltip
                            title="A data será automaticamente preenchida ao validar com sucesso o certificado"
                            placement="top"
                            >[?]</span
                          ></label
                        >
                        <input
                          type="text"
                          v-model="
                            form_certificado_file.dt_expiracao_certificado
                          "
                          v-mask="'##/##/####'"
                          class="form-control"
                          placeholder="Data de Expiração"
                          readonly
                        />
                        <b-form-feedback
                          class="text-danger"
                          v-text="
                            form_certificado_file.errors.get(
                              'dt_expiracao_certificado'
                            )
                          "
                          v-if="
                            form_certificado_file.errors.has(
                              'dt_expiracao_certificado'
                            )
                          "
                        ></b-form-feedback>
                      </b-col>
                    </b-row>

                    <div
                      class="col-md-12"
                      v-if="getPermission('conta.update.certificado')"
                      style="margin-top: 8px"
                    >
                      <b-row>
                        <b-btn
                          @click="onValidarCertificado()"
                          variant="secondary"
                          style="margin-right: 10px"
                        >
                          Enviar certificado
                        </b-btn>
                        <b-btn
                          @click="onUpdateCertificado()"
                          variant="secondary"
                        >
                          Validar Certificado
                        </b-btn>
                        <AvisoErros
                          v-bind:errors_array="errors_array"
                        ></AvisoErros>
                      </b-row>
                    </div>
                  </form>
                </div>
                <div class="col-md-12 pt-1">
                  <h4 class="card-title" style="margin-top: 15px">Logo</h4>
                  <form enctype="multipart/form-data">
                    <b-row>
                      <div class="col-md-5" style="margin-bottom: 5px">
                        <div class="container-fluid">
                          <b-form-file
                            v-model="form_logo.file"
                            :state="Boolean(form.file)"
                            placeholder="Selecione ou arraste o arquivo aqui"
                            drop-placeholder="Solte aqui"
                          ></b-form-file>
                        </div>
                      </div>
                      <div class="col-md-5">
                        <label class="form-label">Logo atual</label><br />
                        <b-img
                          v-bind:src="form_logo.logo_path"
                          fluid
                          alt="Logo"
                        />
                      </div>
                      <div class="col-md-2">
                        <b-btn @click="onUpdateLogo()" variant="secondary">
                          Salvar Logo
                        </b-btn>
                      </div>
                    </b-row>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueClipboard from "vue-clipboard2";
import ToggleButton from "vue-js-toggle-button";
import moment from "moment";
import AvisoErros from "../components/AvisoErros";

Vue.use(VueClipboard);
Vue.use(ToggleButton);

export default {
  components: {
    AvisoErros,
  },
  data() {
    return {
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      teste: "",
      isFullscreen: false,
      loading: false,
      disabled: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      showModalPermission: false,
      optionsCorSistema: [],
      optionsLinkSuporte: [],
      optionsParamTpEmail: [],
      optionsParamTpEmailCte: [],
      optionsCustos: [],
      optionsGeraNumCliente: [],
      corDoSistemaSelected: [],
      custoAdvaloremSelected: [],
      partpemaCteSelected: [],
      partpemaSelected: [],
      errors_array: [],
      data: [],
      error_msg: "",
      form: new Form({
        qtde_horas_cancelamento: "",
        qtde_horas_corte: "",
        qtde_dias_carga_expedida: "",
        qtde_dias_expiracao_gr: "",
        vlr_tolerancia_tabela_frete: "",
        vlr_tolerancia_spot: "",
        vlr_tolerancia_fatura: "",
        vlr_tolerancia_adiantamento: "",
        cotm: "",
        rntrc: "",
        num_cliente: "",
        cor_sistema: "",
        custo_advalorem: "",
        transferencia_interna: "",
        prm_geral_retira: "",
        link_suporte: "",
        gera_num_cliente: "",
        encerra_automatico_vlr_cte_menor: "",
        partpema_cte: "",
        encerra_mdfe_automatico: "",
        valida_regra_adiantamento: "",
        doc_transf_calc_indiv: '',
        partpema: "",
        bloqueio_ocorrencia: "",
        status_canc_exp_erp: "",
        status_canc_cte_com_fatura: "",
        tp_vlr_despacho: "",
      }),
      form_certificado: new Form({
        password_certificado_a1: "",
        dt_expiracao_certificado: "",
        certificado_nome: "",
      }),
      form_certificado_file: new FileForm({
        file: null,
        data: [],
        password_certificado_a1: "",
        dt_expiracao_certificado: "",
        certificado_nome: "",
      }),
      form_logo: new FileForm({
        file: null,
        data: [],
      }),
      helpForm: new Form({
        statusRecord: [],
        senhadicionario: [],
        params: [],
        search: "",
      }),
      moreParams: {},
    };
  },
  watch: {
    corDoSistemaSelected(obj) {
      this.form.cor_sistema = obj.value;
    },
    custoAdvaloremSelected(obj) {
      this.form.custo_advalorem = obj.value;
    },
    partpemaCteSelected(obj) {
      this.form.partpema_cte = obj.value;
    },
    partpemaSelected(obj) {
      this.form.partpema = obj.value;
    },
  },
  mounted() {
    this.$events.$on("filter-set", (eventData) => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", (e) => this.onFilterReset());
    this.$events.$on("reloadResponse", (response) =>
      this.onReloadResponse(response)
    );
  },
  created() {
    let self = this;
    Event.$on("reloadVuetable", function(data) {
      self.onReloadVuetable();
    });
  },
  methods: {
    onChangeStatusCancelamento(e) {
      this.form.status_canc_exp_erp = e.value;
    },
    onChangeStatusCancelamentoFatura(e) {
      this.form.status_canc_cte_com_fatura = e.value;
    },
    onChangeStatusBloqueioOcorrencia(e) {
      this.form.bloqueio_ocorrencia = e.value;
    },
    DateFormat: function(date) {
      if (date != null) {
        return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
      }
      return "";
    },
    disableByRef() {
      this.disabled = true;
    },
    expandFullscreen() {
      this.isFullscreen = !this.isFullscreen;
    },
    cteData() {
      this.loadingData = true;
      this.form
        .get("/api/conta/cte")
        .then((response) => {
          new ReturnApi(response, this);
          this.form.vlr_tolerancia_adiantamento =
            response.data.BConfigBlogistic.vlrToleranciaAdiantamento;
          this.form.qtde_horas_cancelamento =
            response.data.BConfigBlogistic.qtdeHorasCancelamento;
          this.form.qtde_dias_carga_expedida =
            response.data.BConfigBlogistic.qtdeDiasCargaExpedida;
          this.form.qtde_dias_expiracao_gr =
            response.data.BConfigBlogistic.qtdeDiasExpiracaoGr;
          this.form.qtde_horas_corte =
            response.data.BConfigBlogistic.qtdeHorasCorte;
          this.form.cotm = response.data.BConfigBlogistic.cotm;
          this.form.rntrc = response.data.BConfigBlogistic.rntrc;
          this.form.num_cliente = response.data.BConfigBlogistic.numCliente;
          if (response.data.BConfigBlogistic.statusCancExpErp == 1) {
            this.form.status_canc_exp_erp = true;
          } else {
            this.form.status_canc_exp_erp = false;
          }
          if (response.data.BConfigBlogistic.statusCancCteComFatura == 1) {
            this.form.status_canc_cte_com_fatura = true;
          } else {
            this.form.status_canc_cte_com_fatura = false;
          }
          if (response.data.BConfigBlogistic.bloqueioOcorrencia == 1) {
            this.form.bloqueio_ocorrencia = true;
          } else {
            this.form.bloqueio_ocorrencia = false;
          }
          this.form.transferencia_interna =
            response.data.BConfigBlogistic.transferenciaInterna.valor;
          this.form.prm_geral_retira =
            response.data.BConfigBlogistic.prmGeralRetira.valor;
          this.form.link_suporte =
            response.data.BConfigBlogistic.linkSuporte.valor;
          this.form.gera_num_cliente =
            response.data.BConfigBlogistic.geraNumCliente.valor;
          this.form.encerra_automatico_vlr_cte_menor =
            response.data.BConfigBlogistic.encerraAutomaticoVlrCteMenor.valor;
          this.form.encerra_mdfe_automatico =
            response.data.BConfigBlogistic.encerraMdfeAutomatico.valor;
          this.form.tp_vlr_despacho =
            response.data.BConfigBlogistic.tpVlrDespacho.valor;
          this.form.valida_regra_adiantamento =
            response.data.BConfigBlogistic.validaRegraAdiantamento.valor;
          this.form.doc_transf_calc_indiv =
              response.data.BConfigBlogistic.docTransfCalcIndiv.valor;
          this.corDoSistemaSelected = {
            label: response.data.BConfigBlogistic.corSistema.descr,
            value: response.data.BConfigBlogistic.corSistema.valor,
          };
          if (response.data.BConfigBlogistic.vlrToleranciaTabelaFrete != null) {
            this.form.vlr_tolerancia_tabela_frete =
              response.data.BConfigBlogistic.vlrToleranciaTabelaFrete;
          }
          if (response.data.BConfigBlogistic.vlrToleranciaFatura != null) {
            this.form.vlr_tolerancia_fatura =
              response.data.BConfigBlogistic.vlrToleranciaFatura;
          }
          if (response.data.BConfigBlogistic.vlrToleranciaSpot != null) {
            this.form.vlr_tolerancia_spot =
              response.data.BConfigBlogistic.vlrToleranciaSpot;
          }
          (this.custoAdvaloremSelected = {
            label: response.data.BConfigBlogistic.custoAdvalorem.descr,
            value: response.data.BConfigBlogistic.custoAdvalorem.custoId,
          }),
            (this.partpemaCteSelected = {
              label: response.data.BConfigBlogistic.paramTipoEmailCte.descr,
              value:
                response.data.BConfigBlogistic.paramTipoEmailCte.partpema_id,
            }),
            (this.partpemaSelected = {
              label:
                response.data.BConfigBlogistic.paramTipoEmailAverbacao.descr,
              value:
                response.data.BConfigBlogistic.paramTipoEmailAverbacao
                  .partpema_id,
            });
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
          this.error_msg = errors.message;
        });
      this.loadingData = false;
    },
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        this.onUpdate(this.form.id);
      }
    },
    onUpdateCte() {
      this.loading = true;
      this.isDisabled = true;
      this.form
        .post("/api/conta/update/cte")
        .then((response) => {
          new ReturnApi(response, this);
          this.cteData();
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onUpdateCertificado() {
      this.loading = true;
      this.isDisabled = true;
      this.form_certificado
        .post("/api/conta/validar/certificado")
        .then((response) => {
          new ReturnApi(response, this);
          this.cteData();
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach((obj) => {
                  this.errors_array.push({
                    erro: obj,
                  });
                });
              }
            }
          }
        });
    },
    //rota para envio da nova logo é necessaria
    onLogo() {
      this.loading = true;
      this.isDisabled = true;
      this.data = [];
      this.data.push({
        label: "file",
        value: this.form_logo.file,
      });
      this.form_logo.data = this.data;
      this.form_logo
        .upload("/api/conta/validar/certificado")
        .then((response) => {
          new ReturnApi(response, this);
          this.cteData();
        })
        .catch((errors) => {
          new ReturnApi(errors, this);
        });
    },
    onValidarCertificado() {
      this.loading = true;
      this.isDisabled = true;
      this.data = [];
      this.data.push({
        label: "file",
        value: this.form_certificado_file.file,
      });
      this.data.push({
        label: "password_certificado_a1",
        value: this.form_certificado_file.password_certificado_a1,
      });
      this.data.push({
        label: "dt_expiracao_certificado",
        value: this.form_certificado_file.dt_expiracao_certificado,
      });
      this.data.push({
        label: "certificado_nome",
        value: this.form_certificado_file.certificado_nome,
      });
      this.form_certificado_file.data = this.data;
      this.form_certificado_file
        .upload("/api/conta/update/certificado_file")
        .then((response) => {
          new ReturnApi(response, this);
          alert(
            "Centificado enviado com sucesso, clique em Validar Certificado"
          );
          this.cteData();
        })
        .catch((errors) => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          this.errors_array.push({
            erro: "Os campos senha e arquivo são obrigatórios",
          });
        });
    },
    onReloadVuetable() {
      this.$refs.vuetable.reload();
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    onReloadResponse(response) {
      new ReturnApi(response, this);
    },
    limitText(count) {
      return " e ${count} outros clientes";
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    },
  },
  computed: {
    user: {
      get() {
        return this.$store.state.logged.user;
      },
    },
    b_plano: {
      get() {
        return this.$store.getters.bplano;
      },
    },
    getCurrency: {
      get() {
        return this.$store.getters.currency;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
  },
};
</script>
